export const GamepadPortraitLayout = {
    ClassicLayout: { header: 0.4, content: 0.6, footer: 0 },
    ClassicLayoutWithNav: { header: 0.4, content: 0.5, footer: 0.1 },
}

export const GamepadLandscapeLayout = {

}